/**
 * Product discount code block: copy code on click, show green tick for a few seconds.
 */
(function () {
  const COPIED_STATE_DURATION_MS = 3000;

  function init() {
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
  }

  function handleClick(evt) {
    const block = evt.target.closest('.product-discount-code');
    if (!block) return;
    evt.preventDefault();
    copyCode(block);
  }

  function handleKeydown(evt) {
    if (evt.key !== 'Enter' && evt.key !== ' ') return;
    const block = evt.target.closest('.product-discount-code');
    if (!block) return;
    evt.preventDefault();
    copyCode(block);
  }

  function copyCode(block) {
    const code = block.getAttribute('data-code');
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        setCopiedState(block);
      }).catch(function () {
        fallbackCopy(block, code);
      });
    } else {
      fallbackCopy(block, code);
    }
  }

  function fallbackCopy(block, code) {
    try {
      const input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopiedState(block);
    } catch (e) {
      // ignore
    }
  }

  function setCopiedState(block) {
    block.classList.add('is-copied');
    clearTimeout(block._copyTimeout);
    block._copyTimeout = setTimeout(function () {
      block.classList.remove('is-copied');
    }, COPIED_STATE_DURATION_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
